// extracted by mini-css-extract-plugin
export default {"labelvalue":"e73f562a3a00","impact":"d249c39e0d16","tags":"af1190426320","tag":"e9f9b894a7e6","about":"a5e292d3aed5"};